export default __webpack_public_path__ + "static/media/visual-logo.824e3264.png";